import React from "react"
import { Navigate } from "react-router-dom"

import { FEATURES_TYPE, ONE_WAY_ROUTES, USER_ROUTES } from '@constants'
import AppLayout from "Layout"
import { isIrisUser } from "Layout/PmsAgentWidget"
import { newBadge } from "Layout/menu"
import UserSettingPage from "./Settings"
import CustomMappingPage from './CustomMapping'
import UserIrisPage from './Iris'
import { settingsRedirects } from './Settings/@services/tabs'


// A factory since CU-869fmherf: the Iris page is a child only for who sees the launcher (same
// predicate, no new list); for the rest `/user/iris` falls into the 404
export const UserSettingsRoutes = userData => ({
	id: FEATURES_TYPE.COMMON,
	path: USER_ROUTES.PATH,
	title: USER_ROUTES.TITLE,
	icon: 'user',
	element: <AppLayout/>,
	children: [{
		element: <Navigate to={USER_ROUTES.SETTINGS_PATH} replace/>, index: true
	}, {
		path: USER_ROUTES.SETTINGS_PATH,
		title: USER_ROUTES.SETTINGS_SUBTITLE,
		element: <UserSettingPage/>
	},  {
		path: USER_ROUTES.CUSTOM_MAPPING_PATH,
		title: USER_ROUTES.CUSTOM_MAPPING_SUBTITLE,
		element: <CustomMappingPage/>
	}, ...(isIrisUser(userData) ? [{
		path: USER_ROUTES.IRIS_PATH,
		title: USER_ROUTES.IRIS_SUBTITLE,
		element: <UserIrisPage/>,
		// "NEW" while listed in `NEW_UNTIL` (CU-869fmherf batch 5)
		...newBadge('iris', new Date()),
	}] : [])]
})


// Always there, whatever the features (CU-869fmhmx8 E6): One Way's old Acriss Groups page opens Settings › Acriss
// groups, which every user has. Was inside the One Way routes (CU-869fkp1t3)
export const UserRedirectRoutes = () => settingsRedirects({
	oneWayAcrissGroups: ONE_WAY_ROUTES.ACRISS_GROUPS_PATH, settings: USER_ROUTES.SETTINGS_PATH,
}).map(({ path, to }) => ({ path, element: <Navigate to={to} replace/> }))
